/**
 * Convert duration from minutes to a human-readable format (hours and minutes).
 * @param {number} minutes - The duration in minutes.
 * @returns {string} - Formatted duration string.
 */
export const formatDuration = (minutes) => {
    if (minutes == null || isNaN(minutes) || minutes < 0) {
        return "invalid";  // Handle invalid cases
    }

    const hours = Math.floor(minutes / 60);  // Convert to whole hours
    const remainingMinutes = minutes % 60;  // Get remaining minutes

    if (hours > 0 && remainingMinutes > 0) {
        return `${hours} Hour${hours > 1 ? 's' : ''} ${remainingMinutes} Minute${remainingMinutes > 1 ? 's' : ''}`;
    } else if (hours > 0) {
        return `${hours} Hour${hours > 1 ? 's' : ''}`;
    } else {
        return `${remainingMinutes} Minute${remainingMinutes > 1 ? 's' : ''}`;
    }
};

export const formatDuration2 = (minutes) => {
    if (minutes == null || isNaN(minutes) || minutes < 0) {
        return "invalid";  // Handle invalid cases
    }

    const hours = Math.floor(minutes / 60);  // Convert to whole hours
    const remainingMinutes = minutes % 60;  // Get remaining minutes

    if (hours > 0 && remainingMinutes > 0) {
        return `${hours} Hr${hours > 1 ? 's' : ''} ${remainingMinutes} Min${remainingMinutes > 1 ? 's' : ''}`;
    } else if (hours > 0) {
        return `${hours} Hr${hours > 1 ? 's' : ''}`;
    } else {
        return `${remainingMinutes} Min${remainingMinutes > 1 ? 's' : ''}`;
    }
};
